const isPromise = (o: any): boolean => typeof o === 'object' && typeof o.then === 'function'

export type PromiseableProp<T> = T | Promise<T> | (() => T | Promise<T>)
export const isPropResolvedPromise = <T>(prop: PromiseableProp<T>): prop is Promise<T> => isPromise(prop)
export const isPropPromiseFunction = <T>(prop: PromiseableProp<T>): prop is () => Promise<T> =>
    !isPromise(prop) && typeof prop === 'function'
export const resolvePromiseableProp = async <T>(prop: PromiseableProp<T>): Promise<T> => {
    return isPropResolvedPromise(prop) ? prop.then() : isPropPromiseFunction(prop) ? prop() : (prop as T)
}
